<!-- Modal Header -->
<div class="modal-header flex items-center gap-3 mb-6">
    <!-- Icon in colored circle (if defined) -->
    @if (descriptionIcon) {
        <div class="icon-container" [style.background-color]="iconBackgroundColor">
            <!-- Icon as string (Material Icon) -->
            @if (isIconString()) {
                <mat-icon [style.color]="iconColor">
                    {{ descriptionIcon }}
                </mat-icon>
            }
            <!-- Icon as TemplateRef -->
            @else if (isIconTemplate()) {
                <ng-container *ngTemplateOutlet="descriptionIcon"></ng-container>
            }
        </div>
    }

    <!-- Modal Title -->
    <h2 class="modal-title">
        {{ title }}
    </h2>
</div>

<!-- Modal Content/Description -->
<mat-dialog-content class="modal-content">
    <p 
        [class]="descriptionColor + ' text-base leading-relaxed'"
        [innerHTML]="description">
    </p>
</mat-dialog-content>

<!-- Modal Actions (Buttons) -->
<mat-dialog-actions class="modal-actions flex justify-end">
    <button 
        mat-button 
        type="button"
        (click)="onCancel()"
        class="cancel-button">
        {{ cancelButtonText }}
    </button>
    
    <button 
        mat-raised-button 
        type="button"
        (click)="onConfirmAction()"
        class="confirm-button"
        [style.background-color]="buttonBackgroundColor"
        [style.color]="buttonTextColor">
        {{ confirmButtonText }}
    </button>
</mat-dialog-actions>

